// Templates are named "{niche} — {adStyle}" (e.g. "Beauty — Before & After"),
// where the ad STYLE after the em-dash is the brand's real, per-ad winning-ad
// classification — far more accurate than the loose `styleTags` (which stamp
// "Lifestyle"/"Clean"/"Product-focused" on 40-64% of the library). The Discover
// sections and the Ad Library both organize/filter by this.

import type { AdTemplate } from '@shared/schema';

/** The ad style segment after the last em-dash in the template name, or '' if
 *  the name isn't in the "{niche} — {style}" shape. */
export function adStyleOf(t: (Pick<AdTemplate, 'name'> & {adStyle?: string | null}) | null | undefined): string {
  // Scanned ads carry explicit metadata; their title suffix is ad copy.
  if (t && Object.prototype.hasOwnProperty.call(t, 'adStyle')) return t.adStyle?.trim() ?? '';
  const name = t?.name ?? '';
  if (!name.includes('—')) return '';
  const parts = name.split('—');
  return (parts[parts.length - 1] ?? '').trim();
}

// The ad-style taxonomy actually present in the library, ordered by usefulness.
// Used for the Ad Library "Style" filter options.
export const AD_STYLE_OPTIONS = [
  'Before & After', 'Social Proof', 'Problem-Solution', 'Us vs Them', 'Listicle',
  'UGC Style', 'Benefits', 'Features', 'Product Launch', 'Reviews', 'Sale',
  'Education', 'How It Works', 'Myth Busting', 'Testimonial', 'Direct Response',
  'Contrarian', 'Identity', 'Urgency', 'Curiosity Gap', 'Founder Story', 'Dark Mode',
];
